export default "/images/1db2f27a03ea8c49da62bbb2b3895ace.avif";